import augmenters from './augmenters';

export default function addMarkAugmenter(augmenter) {
	if (typeof augmenter !== 'function') return () => {};

	augmenters.add(augmenter);
	return () => augmenters.delete(augmenter);
}
